
<template>
  <v-row
    class="filters-row align-center filters-menu justify-end"
    no-gutters>
    <div class="spacer"/>
    <slot name="append"/>
    <v-menu
      v-if="choosedHeadersShow"
      :close-on-content-click="named_view"
      offset-y>
      <template #activator="{ on, value }">
        <div v-on="on">
          <sButton
            class="mr-4 py-1 px-2 h11-links"
            :color="value ? '#000000a6' : 'var(--black-color)'"
            data-qa="btn-column"
            :disabled="loading"
            icon="column"
            type="text">
            {{ named_view && choosed ? choosed.text : view_name || $t('Planning.View') }}
          </sButton>
        </div>
      </template>
      <div
        class="filters-menu-list menu py-2"
        data-qa="filters-menu-list">
        <v-list-item-group
          v-model="choosed"
          :mandatory="named_view"
          :multiple="!named_view">
          <template v-for="item in allHeaders">
            <v-list-item
              v-if="item.text && !item.disableFilter"
              :key="item.text"
              data-qa="filters-menu-list-item"
              :value="item">
              <template #default="{ active }">
                <v-list-item-action class="my-0 mr-2">
                  <v-checkbox
                    color="var(--black-color)"
                    :input-value="active"
                    :ripple="false"/>
                </v-list-item-action>
                <v-list-item-title>{{ bigFirstLetter(item.text) }}</v-list-item-title>
              </template>
            </v-list-item>
          </template>
        </v-list-item-group>
      </div>
    </v-menu>
    <FiltersBlock
      v-if="!without_filter"
      ref="FiltersBlock"
      :available_types.sync="filter_items"
      :with_mode="with_mode"
      @applyFilters="applyFilters">
      <template #third_activator="{ item, disabled }">
        <slot
          :disabled="disabled"
          :item="item"
          name="third_activator"/>
      </template>
    </FiltersBlock>
    <SearchInput
      v-if="searchShow"
      class="my-2 ml-0 mr-2"
      debounce
      :disabled="loading"
      :search="searchValue"
      @applySearch="applySearch"
      @update:search="removeSharp"/>
    <ModeButtons
      v-if="showTableModeBtns"
      :disabled="loading"
      :mode.sync="tableModeComputed"/>
  </v-row>
</template>
<script>
import SearchInput from 'components/common/inputs/SearchInput.vue'
import FiltersBlock from 'components/common/blocks/FiltersBlock.vue'
import ModeButtons from 'components/common/elements/ModeButtons.vue'

/* eslint-disable vue/prop-name-casing */
import { filtersTemplatesMixin, modalMixin, storageMixin } from 'mixins'

export default {
  name: 'filterBar',
  mixins: [ modalMixin, storageMixin, filtersTemplatesMixin],
  data() {
    return {
      search_value: '',
      periodDialog: false,
      date_from: '',
      searchPeriod: '',
      getFiltersCount: 0,
      date_to: '',
      menu: false,
      old_mode: true,
      key: 0,
    }
  },
  props: {
    customClass: String,
    allHeaders: Array,
    filter_types: Array,
    choosedHeaders: [Array, Object],
    /**
     * Отобразить выбор колонок
     */
    choosedHeadersShow: {
      type: Boolean,
    },
    without_filter: Boolean,
    named_view: Boolean,
    view_name: String,
    /**
    * режим таблицы/карточки
    **/
    tableMode: {
      type: Boolean,
    },
    /**
     * Отобразить кнопки режима таблицы/карточки
     */
    showTableModeBtns: {
      type: Boolean,
    },
    loading: Boolean,
    with_mode: {
      type: Boolean,
      default: true
    },
    /**
     * отображать строку с поиском
     */
    searchShow: {
      type: Boolean,
      default: true
    },
  },
  computed: {
    /** режим таблицы/карточки */
    tableModeComputed: {
      get() {
        return this.tableMode
      },
      set(value) {
        this.$emit('update:tableMode', value)
      }
    },
    searchValue: {
      get() {
        return this.search_value || ''
      },
      set(value) {
        this.search_value = value
      }
    },
    choosed: {
      get() {
        return this.choosedHeaders
      },
      set(val) {
        this.$emit('update:choosedHeaders', val || this.choosedHeaders)
      }
    },
    filter_items() {
      let filters = []
      if (this.filter_types) {
        filters = this.filter_types
      } else {
        filters = this.allHeaders.filter(el => el.setFilter)
      }
      filters.forEach(el => el.text = this.bigFirstLetter(el.text))
      return filters.map(el => ({
        id: el.value,
        title: el.text,
        contain: true,
        search: [],
        type: el.type,
      }))
    },
  },
  methods: {
    removeSharp(value) {
      this.searchValue = value.replace(/^#|#$/g, '')
    },
    applyFilters(filters, mode) {
      this.$emit('applyFilters', filters, mode, this.searchValue)

      this.$_saveFiltersToDBStorage({filters, filters_mode: mode, search: this.searchValue})
    },
    applySearch() {
      this.$emit('applySearch', this.searchValue)
      this.$root.$emit('loadData', {search: this.searchValue})

      this.$_saveFiltersToDBStorage({search: this.searchValue})
    },
  },
  components: {
    SearchInput,
    ModeButtons,
    FiltersBlock
  }
}
</script>
